import React from "react";
import FavoriteClient from "../lib/Restful/FavoriteClient";
const client = FavoriteClient;
class Favorite extends React.Component {
    constructor(props) {
        super(props);
        this.click = (e) => {
            e.preventDefault();
            if (!this.props.logged_in) {
                alert('この機能を利用するにはログインしてください');
                return;
            }
            const id = this.props.id;
            (this.state.active ? client.delete(id) : client.post(id));
        };
        this.loading = (data) => {
            this.setState({
                loading: data.indexOf(this.props.id) >= 0,
            });
        };
        this.handle = (data) => {
            this.setState({
                loading: false,
                active: data.indexOf(this.props.id) >= 0,
            });
        };
        this.state = {
            active: false,
            loading: true,
        };
        if (this.props.logged_in) {
            client
                .on('connect', this.loading)
                .on('change', this.handle)
                .get();
        }
    }
    label() {
        var _a;
        const labels = (_a = this.props) === null || _a === void 0 ? void 0 : _a.labels;
        return (this.state.active ? labels === null || labels === void 0 ? void 0 : labels.on : labels === null || labels === void 0 ? void 0 : labels.off) || '';
    }
    render() {
        const props = this.props, state = this.state, label = this.label();
        if (props.parent) {
            const c = props.parent.classList;
            c.toggle('active', state.active);
            c.toggle('loading', state.loading);
        }
        return (React.createElement("button", { type: "button", className: "recommend-action", onClick: this.click },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 530 500" },
                React.createElement("path", { d: "M459.2 91.2C405.9 37.9 320.1 36.4 265 86.6 239.1 63 205.7 50 170.3 50c-37.6 0-72.9 14.6-99.5 41.2-53.7 53.7-54.4 138.6-1.5 197.4L265 462l195.6-173.5c52.9-58.7 52.3-143.6-1.4-197.3z" })),
            label !== '' &&
                React.createElement("span", null, label)));
    }
}
export default Favorite;
